define( function() {
	return ( /<([\w:-]+)/ );
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/manipulation/var/rtagName.js
// module id = 344
// module chunks = 1